import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Video } from './video.model';
import videoService from './video.service';

// namespace
export const VIDEO_STORE_NAMESPACE = 'videoStore';

// state
interface VideoState {
  videos: Video[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: VideoState = {
  videos: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  FIND: 'find',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<VideoState> = {
  [mutationConstant.FETCH]: (state: VideoState, videos: Video[]) => {
    state.videos = videos;
  },
  [mutationConstant.FIND]: (state: VideoState, video: Video) => {
    if (state.videos.some(m => m.id === video.id)) {
      const index = state.videos.findIndex(m => m.id === video.id);
      state.videos[index] = video;
    } else {
      state.videos.push(video);
    }
  },
  [mutationConstant.PENDING]: (state: VideoState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: VideoState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: VideoState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
  FIND: 'find',
};

const action: ActionTree<VideoState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<VideoState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      videoService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
  [actionConstant.FIND](context: ActionContext<VideoState, RootState>, id: number) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      videoService.Find(id)
        .then((response) => {
          context.commit(mutationConstant.FIND, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<VideoState, RootState> = {
  [getterConstant.ALL]: (state: VideoState) => state.videos,
  [getterConstant.BY_ID]: (state: VideoState) => (id: number) => state.videos.find(m => m.id === id),
  [getterConstant.STATUS]: (state: VideoState) => state.status,
};

// module
const module: Module<VideoState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const VideoGetter = {
  ALL: `${VIDEO_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${VIDEO_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${VIDEO_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const VideoAction = {
  FETCH: `${VIDEO_STORE_NAMESPACE}/${actionConstant.FETCH}`,
  FIND: `${VIDEO_STORE_NAMESPACE}/${actionConstant.FIND}`,
};

export default module;
